import { styled } from 'styled-components';

import UpdatesSVG from '../assets/updates-icon.svg?react';

export const StyledUpdatesIcon = styled(UpdatesSVG)`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
`;
